import { Route } from "react-router-dom";

import { db } from "astrid-firebase";

import ForwardContext from "../../../layouts/ForwardContext";

import { artifact } from "../../artifacts/routes/artifacts";
import FirestoreDocumentElement from "../../firebase/components/FirestoreDocumentElement";

import Work from "../pages/Work";
import WorkOverview from "../pages/WorkOverview";
import Works from "../pages/Works";

const work = (
	<Route
		path=":work"
		element={<FirestoreDocumentElement param="work" collection={db.collection("works")} />}
		handle={{ crumb: ({ work }) => work?.name }}
	>
		<Route element={<Work />}>
			<Route index element={<WorkOverview />} />
		</Route>

		<Route path="artifacts">{artifact}</Route>

		<Route path="articles">
			<Route
				path=":article"
				element={<FirestoreDocumentElement param="article" collection={db.collection("articles")} />}
			>
				<Route path="artifacts">{artifact}</Route>
			</Route>
		</Route>
	</Route>
);

export const works = (
	<Route path="works" element={<ForwardContext />} handle={{ crumb: ({ t }) => t("works", "Works") }}>
		<Route index element={<Works />} />

		{work}
	</Route>
);
